module.exports = __webpack_public_path__ + "static/media/food.8bab732c.svg";